import { styled } from '@linaria/react';

import { ImageBaseWrapper } from '../styles';

export const PaidImageWrapper = styled(ImageBaseWrapper)`
	cursor: pointer;
`;

export const PaidImageInner = styled.div`
	position: relative;
	overflow: hidden;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
	justify-content: center;
	row-gap: 8px;
	width: 100%;
	height: 100%;
	pointer-events: none;
	color: var(--color-white-05);
	background: radial-gradient(
			75% 75% at 50% 50%,
			rgba(0, 0, 0, 0) 0%,
			rgba(0, 0, 0, 0.8) 100%
		),
		rgba(0, 0, 0, 0.5);
	border-radius: 24px;

	p {
		color: inherit;
	}

	&:has(> img) {
		background: none;
		.loader {
			position: absolute;
			left: 0;
			top: 0;
		}
	}

	& > img {
		position: absolute;
		left: 0;
		top: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		border-radius: 24px;
		object-fit: cover;
		transition: filter 0.2s, transform 0.3s, opacity 0.2s;
	}
`;
